import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Button from '../../Common/Button';
import Toggle from '../../Common/Toggle/Toggle';
import { CsvToIntArray } from '../../../helpers/strings';
import '../Reports.scss';

export class ProjectListFilters extends React.Component {

    constructor(props, context) {
        super(props, context);

        const initialFormSelections = {
            locationKeys: [],
            isOnlyMyLocations: true,
            brandIds: '',
            countryIds: '',
            regionIds: '',
            locationTypeIds: '',
            continentIds: '',
            areaIds: '',
            activeRetiredCode: ''
        }

        this.state = {
            emptyForm: initialFormSelections,
            continentIds: initialFormSelections.continentIds,
            areaIds: initialFormSelections.areaIds,
            regionIds: initialFormSelections.regionIds,
            brandIds: initialFormSelections.brandIds,
            locationTypeIds: initialFormSelections.locationTypeIds,
            countryIds: initialFormSelections.countryIds,
            isOnlyMyLocations: initialFormSelections.isOnlyMyLocations,
            activeRetiredCode: initialFormSelections.activeRetiredCode,
            activeRetiredCodeOptions: [{ id: 'Active', name: 'Active' }, { id: 'Retired', name: 'Retired' }]
        }
    }

    componentDidMount = async () => {
        /**
         * Must set defaults before registering report filter functions, because
         * these defaults might be overridden by mapToForm values coming from
         * the API when opening a scheduled report.
         */
        this.setDefaults();
        /**
         * On mount, register all of this form's callbacks so the parent is able
         * to use them when its wrapping UI indicates these actions should be
         * performed.
         */
        this.props.registerReportFilterFunctions(
            this.props.report.id,
            this.clearForm,
            this.validateForm,
            this.mapToForm,
            this.mapToApiRequest
        );
    }

    setDefaults = () => {
        let newState = { ...this.state };

        const appState = this.props.savedFilterValues;
        if (appState) {
            // Set new state to values from redux app state
            newState = {
                ...newState,
                continentIds: appState.continentIds ? appState.continentIds : newState.continentIds,
                areaIds: appState.areaIds ? appState.areaIds : newState.areaIds,
                regionIds: appState.regionIds ? appState.regionIds : newState.regionIds,
                brandIds: appState.brandIds ? appState.brandIds : newState.brandIds,
                locationTypeIds: appState.locationTypeIds ? appState.locationTypeIds : newState.locationTypeIds,
                countryIds: appState.countryIds ? appState.countryIds : newState.countryIds,
                isOnlyMyLocations: appState.isOnlyMyLocations ? appState.isOnlyMyLocations : newState.isOnlyMyLocations,
                activeRetiredCode: appState.activeRetiredCode ? appState.activeRetiredCode : newState.activeRetiredCode
            }
        }

        this.setState({
            ...this.state,
            ...newState
        });
    }

    clearForm = () => {
        this.setState({
            ...this.state,
            ...this.state.emptyForm
        });
    }

    validateForm = () => {
        return true;
    }

    mapToForm = (reportRequest) => {
        const form = { ...this.state.emptyForm };

        form.isOnlyMyLocations = (reportRequest.isOnlyMyLocations === true) ? true : false;
        form.brandIds = (reportRequest.brandIds) ? reportRequest.brandIds.join(',') : form.brandIds;
        form.countryIds = (reportRequest.countryIds) ? reportRequest.countryIds.join(',') : form.countryIds;
        form.regionIds = (reportRequest.regionIds) ? reportRequest.regionIds.join(',') : form.regionIds;
        form.locationTypeIds = (reportRequest.locationTypeIds) ? reportRequest.locationTypeIds.join(',') : form.locationTypeIds;
        form.continentIds = (reportRequest.continentIds) ? reportRequest.continentIds.join(',') : form.continentIds;
        form.areaIds = (reportRequest.areaIds) ? reportRequest.areaIds.join(',') : form.areaIds;
        form.activeRetiredCode = (reportRequest.activeRetiredCode) ? reportRequest.activeRetiredCode : form.activeRetiredCode;

        this.setState({
            ...this.state,
            ...form
        });
    }

    mapToApiRequest = () => {

        const request = {
            showMoreFields: false,
            reportId: this.props.report.id,
            isOnlyMyLocations: this.state.isOnlyMyLocations,
            brandIds: CsvToIntArray(this.state.brandIds),
            countryIds: CsvToIntArray(this.state.countryIds),
            regionIds: CsvToIntArray(this.state.regionIds),
            locationTypeIds: CsvToIntArray(this.state.locationTypeIds),
            continentIds: CsvToIntArray(this.state.continentIds),
            areaIds: CsvToIntArray(this.state.areaIds),
            activeRetiredCode: this.state.activeRetiredCode
        };

        return {
            apiRequest: request,
            formValues: this.state
        };
    }

    onToggleShowMore = () => {
        this.setState({
            showMoreFields: !this.state.showMoreFields
        });
    }

    onFieldChange = (name, value) => {
        this.setState({ ...this.state, [name]: value });
    }

    onDropdownChange = (value, name) => {
        this.onFieldChange(name, value);
    }

    render() {
        const showMoreText = this.state.showMoreFields ? "Show Less Filters" : "Show More Filters";
        return (
            <form id="subForm" noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <Toggle name="isOnlyMyLocations"
                            text="Only Include My Locations"
                            checked={this.state.isOnlyMyLocations}
                            onChange={this.onFieldChange} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="activeRetiredCode"
                            label="Project Status" idField="id" valueField="name"
                            options={this.state.activeRetiredCodeOptions}
                            selectedValues={this.state.activeRetiredCode.toString()}
                            onChange={this.onDropdownChange}
                            isMulti={true} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="continentIds"
                            label="Continent" idField="id" valueField="name"
                            options={this.props.filters.continents}
                            selectedValues={this.state.continentIds.toString()}
                            onChange={this.onDropdownChange}
                            isMulti={true} />
                    </div>
                </div>
                {this.state.showMoreFields &&
                    <Fragment>
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="brandIds"
                                    label="Brand" idField="id" valueField="name"
                                    options={this.props.filters.brands}
                                    selectedValues={this.state.brandIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="regionIds"
                                    label="Region" idField="id" valueField="name"
                                    options={this.props.filters.regions}
                                    selectedValues={this.state.regionIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="areaIds"
                                    label="Area" idField="id" valueField="name"
                                    options={this.props.filters.areas}
                                    selectedValues={this.state.areaIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isMulti={true} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="countryIds"
                                    label="Country" idField="id" valueField="name"
                                    options={this.props.filters.countries}
                                    selectedValues={this.state.countryIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <MultiSelectBox name="locationTypeIds"
                                    label="Location Type" idField="id" valueField="name"
                                    options={this.props.filters.locationTypes}
                                    selectedValues={this.state.locationTypeIds.toString()}
                                    onChange={this.onDropdownChange}
                                    isMulti={true} />
                            </div>
                            <div className="col-sm-12 col-md-4">

                            </div>
                        </div>
                    </Fragment>
                }

                <div className="row text-end">
                    <div className="col-sm-12">
                        <Button name="showMore" type="button" bootstrapClass="link" text={showMoreText} onClick={this.onToggleShowMore} />
                    </div>
                </div>
            </form>
        );
    }
}

ProjectListFilters.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    registerReportFilterFunctions: PropTypes.func.isRequired,
    urlParams: PropTypes.object.isRequired,
    savedFilterValues: PropTypes.object.isRequired
};

export default ProjectListFilters;
